export const GLOBAL_URL_FILTER_ID = "all";
